import React from 'react';
import { CheckCircle2, Download } from 'lucide-react';
import LeadForm from './LeadForm';

const HeroBanner = ({ onOpenBrochure }) => {
  return (
    <section className="hero-banner">
      <div className="hero-bg-doodle">
        <svg viewBox="0 0 857 807" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M822.111 798.287C726.777 422.993 686.613 346.036 629.108 366.093C571.602 386.15 595.871 514.624 614.617 614.802C629.342 693.487 570.052 740.303 490.19 653.214C369.849 521.984 317.484 329.846 359.906 276.942C442.516 173.918 518.514 640.678 424.823 675.188C280.533 728.335 128.532 390.773 34.8986 9"
            stroke="#FFD54F"
            strokeOpacity="0.25"
            strokeWidth="60"
          />
        </svg>
      </div>

      <div className="hero-container">
        <div className="hero-left">
          <div className="degree-tag">Master of Business Administration</div>
          <h1 className="hero-title">
            <span>Online MBA</span> courses from <br />
            <span className="gradient-text">Manipal Universities</span>
          </h1>

          <ul className="accreditations-list">
            <li>
              <CheckCircle2 size={20} className="check-font-icon" />
              <span>UGC-Entitled & NAAC A+ Accredited</span>
            </li>
            <li>
              <CheckCircle2 size={20} className="check-font-icon" />
              <span>Trusted by <strong>1,75,000+</strong> Learners</span>
            </li>
            <li>
              <CheckCircle2 size={20} className="check-font-icon" />
              <span>From Some of India's Best Private Universities</span>
            </li>
          </ul>

          <div className="hero-cta-group">
            <button className="btn-outline-hero" onClick={onOpenBrochure}>
              <Download size={18} />
              Download Brochure
            </button>
          </div>
        </div>

        <div className="hero-right">
          <LeadForm />
        </div>
      </div>
    </section>
  );
};

export default HeroBanner;
